import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import Alert from 'react-s-alert';
import { get } from 'session';
import PropTypes from 'prop-types';
import { customStyle } from 'helper';
import * as actions from '../action';
import * as c from '../constant';
import BarangayContent from './BarangayContent';
import BarangayModal from '../components/BarangayModal';

const form = {
  keyword: '',
};

function BarangayContainer({
  match,
  history,
  getBarangayList,
  barangayList,
  isLoading,
  removeBarangay,
  barangayListPager,
  getSingleBarangay,
  getDistrictList,
  districtList,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);
  const [district, setDistrict] = useState({
    label: '',
    value: 0,
  });

  const handleChangeSelect = (e) => {
    setDistrict(e);
    getBarangayList({ rptax_district_id: e.value, isPaginate: 1 });
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <BarangayModal type="NEW" />,
      title: 'Add Barangay',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <BarangayModal type="EDIT" updateList={data.attributes} barangayId={data.id} />,
      title: 'Update Barangay',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this Barangay?',
      () => {
        removeBarangay(data.id, () => {
          getBarangayList({ isPaginate: 1 });
          const id = _.get(barangayList, '0.id');
          if (id !== data.id) {
            history.push(`${id}`);
            getSingleBarangay(id);
          } else {
            window.location.pathname = '/rpt/settings/property-locations/barangays';
            history.replace({
              pathname: '/rpt/settings/property-locations/barangays',
            });
          }
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getBarangayList({ isPaginate: 1 });
    getDistrictList({ isPaginate: 1 });
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getBarangayList({ isPaginate: 1, q: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  const token = get('token') || '';

  const [file, setFile] = useState({});

  const fileHandler = (e) => {
    setFile(e.target.files[0]);
  };

  const postFormData = url => (formdata, onProgress) => new Promise((resolve, reject) => {
    try {
      const xhr = new XMLHttpRequest();
      xhr.timeout = 300000;
      // eslint-disable-next-line no-unused-vars
      xhr.addEventListener('timeout', e => resolve({
        status: 400,
        message: 'Request Timeout, Please try again.',
      }));
      xhr.open('POST', url);
      xhr.setRequestHeader('Authorization', `Bearer ${token}`,);
      xhr.onload = () => {
        try {
          const jsonResponse = JSON.parse(xhr.response);
          const response = {
            status: xhr.status, // jsonResponse.status,
            data: jsonResponse,
          };
          resolve(response);
        } catch (err) {
          reject(err);
        }
      };
      xhr.onerror = () => {
        const errRes = {
          data: false,
          message: 'Oops..Something went wrong.',
        };
        Alert.error(errRes);
        return resolve(errRes);
      };
      if (xhr.upload) {
        xhr.upload.onprogress = (evt) => {
          if (evt.lengthComputable) {
            const progress = Math.ceil(((evt.loaded) / evt.total) * 100);
            if (onProgress) { onProgress(progress); }
          }
        };
      }
      xhr.send(formdata);
    } catch (err) {
      reject(err);
    }
  });

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  const onUploadFile = async (e) => {
    e.preventDefault();

    const data = new FormData();
    try {
      data.append('file', file);
      data.append(
        'subject',
        'BARANGAY'
      );
      const res = await postFormData(`${process.env.REACT_APP_WS}api/v1/rpt/administrator/settings/csv_imports`)(data);
      if (_.get(res, 'status') === 200) {
        Alert.success(_.get(res, 'data.message'));
        getBarangayList({ isPaginate: 1 });
      }
      if (_.get(res, 'status') === 422) {
        Alert.error(_.get(res, 'data.message'));
      }
      if (_.get(res, 'status') === 400) {
        const message = _.get(res, 'data.errors.0.detail');
        Alert.error(message);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err, 'err');
    }
  };

  return (
    <div className="card-content-listing">
      <div className="ml-auto row-nav">
        <div className="float-left">
          <div className="form-group">
            {isLoading && (
              <button
                disabled
                type="button"
                className="btn btn-light btn-round border border-primary font-weight-bold px-4 ml-auto"
              >
                <i className="fa fa-spin fa-spinner" />
              </button>
            )}
          </div>
        </div>
        <div className="float-right">
          <div className="form-group">
            {!isLoading && (
              <input
                type="file"
                className="btn btn-link input-upload"
                onChange={fileHandler}
              />
            )}
          </div>
        </div>
        <div className="flow-right">
          <div className="form-group">
            <button type="button" onClick={onUploadFile} className="ml-2 btn btn-link button-upload">
              Upload
            </button>
          </div>
        </div>
      </div>
      <div className="p-0 mb-3 mt-3">
        <div className="container-fluid  px-0">
          <div className="d-inline w-auto d-flex justify-content-start m-3">
            <label className="label-transaction-card mb-0 d-flex align-items-center mr-3">
              Select District:
            </label>
            <div style={{ width: 250 }}>
              <Select
                styles={customStyle}
                placeholder="Select District"
                value={district}
                options={createDropdown(districtList)}
                onChange={handleChangeSelect}
              />
            </div>
          </div>
        </div>
      </div>
      <Route
        path={`${match.path}/:barangayId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Barangays"
            getData={getBarangayList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:barangayId?`}
            listName="Barangays"
            label="Barangays"
            renderItem={(item) => (
              <div className="p-3">{_.get(item, 'attributes.name')}</div>
            )}
            isLoading={isLoading}
            selected={params.barangayId}
            data={barangayList}
            dataPager={barangayListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:barangayId?`}
                    render={() => (
                      <BarangayContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:barangayId?`}
                  render={() =>
                    (!params.barangayId || barangayList.length > 0) ? (
                      <Redirect
                        to={`${match.url}/${_.get(barangayList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

BarangayContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  barangayListPager: PropTypes.instanceOf(Object).isRequired,
  removeBarangay: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getSingleBarangay: PropTypes.instanceOf(Function).isRequired,
  getDistrictList: PropTypes.instanceOf(Function).isRequired,
  districtList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  districtList: _.get(api, `${c.GET_DISTRICT_LIST}.list`) || [],
  barangayListPager: _.get(api, `${c.GET_BARANGAYS}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_BARANGAYS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BarangayContainer);
